module.exports = __webpack_public_path__ + "static/img/coreProductb.502ab49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coreProductb.png
// module id = qXm6
// module chunks = 1